import type { ReactNode } from "react"
import { ChevronLeft } from "lucide-react"
import { cn } from "@/lib/utils"
import { Button } from "../Button/Button"

export interface SettingsLayoutProps {
  children: ReactNode
  backLabel?: string
  onBack?: () => void
  maxWidthClassName?: string
  className?: string
}

export function SettingsLayout({
  children,
  backLabel = "Back",
  onBack,
  maxWidthClassName = "max-w-6xl",
  className,
}: SettingsLayoutProps) {
  return (
    <div
      className={cn(
        "h-full overflow-y-auto pt-4 pb-6 px-6 md:px-10 lg:px-14 w-full mx-auto",
        maxWidthClassName,
        className,
      )}
    >
      {onBack && (
        <Button
          variant="ghost"
          size="sm"
          className="text-label -ml-3 mb-4 gap-1 motion-safe:active:scale-[0.97] motion-safe:transition-transform motion-safe:duration-100"
          onClick={onBack}
        >
          <ChevronLeft size={14} strokeWidth={1.75} />
          {backLabel}
        </Button>
      )}
      {children}
    </div>
  )
}
